module.exports = __webpack_public_path__ + "img/SEJ_Eventos_casillas de verificacion.42506ce8.svg";